<template>
  <router-link :to="`${to}?history=back`" class="back">
    <svg width="22" height="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.214 9.214l4.655 4.655a1.179 1.179 0 0 1-1.667 1.667l-7.5-7.5 1.667-1.667L8.202.535A1.179 1.179 0 1 1 9.87 2.202L5.214 6.857h15.607a1.179 1.179 0 0 1 0 2.357H5.214z" fill="#FFF" fill-rule="evenodd"/>
    </svg>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  position: absolute;
  top: 0;
  left: 0;
  padding: 25px 30px;
}
</style>
